import StatusLegendData from "../../../../../common/components/status-legend/types/status-legend-data";
import StatusLegendStatuses from "../../../../../common/components/status-legend/types/status-legend-statuses";

const getStatusOptions = (): StatusLegendData[] => {
  const statuses: StatusLegendStatuses[] = [
    StatusLegendStatuses.OPTIMIZATION_PENDING,
    StatusLegendStatuses.OPTIMIZATION_INTERESTING,
    StatusLegendStatuses.OPTIMIZATION_REJECTED,
  ];

  return statuses.map((status) => {
    return {
      status,
    };
  });
};

const orderOptimzierRailyListingHelper = {
  getStatusOptions,
};

export default orderOptimzierRailyListingHelper;
